import React from 'react';
import { Helmet } from 'react-helmet-async';
import { canonicalBaseUrl, defaultOgImagePath, siteName } from '../seo/siteConfig';

/**
 * Per-route SEO: canonical, Open Graph, Twitter. Crawlers that run without JS still see index.html defaults.
 */
export default function PageSeo({
  title,
  description,
  pathname,
  ogTitle,
  ogDescription,
  ogImagePath,
  noindex,
}) {
  const canonical = `${canonicalBaseUrl}${pathname === '/' ? '' : pathname}`;
  const imageRel = ogImagePath ?? defaultOgImagePath;
  const ogImage = imageRel.startsWith('http') ? imageRel : `${canonicalBaseUrl}${imageRel}`;
  const ogT = ogTitle ?? title;
  const ogD = ogDescription ?? description;
  const indexable = !noindex;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {indexable && <link rel="canonical" href={canonical} />}

      {indexable && (
        <>
          <meta property="og:type" content="website" />
          <meta property="og:url" content={canonical} />
          <meta property="og:title" content={ogT} />
          <meta property="og:description" content={ogD} />
          <meta property="og:image" content={ogImage} />
          <meta property="og:site_name" content={siteName} />
          <meta property="og:locale" content="en_ZA" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content={canonical} />
          <meta name="twitter:title" content={ogT} />
          <meta name="twitter:description" content={ogD} />
          <meta name="twitter:image" content={ogImage} />
        </>
      )}

      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
    </Helmet>
  );
}
